module.exports = __webpack_public_path__ + "img/Qualys.273b83f.svg";